// extracted by mini-css-extract-plugin
export var content = "_du-3";
export var list = "_du-4";
export var settingsContent = "_du-7";
export var settingsPanel = "_du-8";
export var state = "_du-6";
export var triggerBadge = "_du-2";
export var triggerButton = "_du-1";
export var triggerShell = "_du-0";
export var unreadDot = "_du-5";